import apiClient from './apiClient';

class DashboardService {
    /**
     * Get comprehensive dashboard statistics
     */
    async getDashboardStats(fromDate = null, toDate = null) {
        try {
            const params = {};
            if (fromDate) params.from_date = fromDate;
            if (toDate) params.to_date = toDate;
            
            const response = await apiClient.get('/dashboard/stats', { params });
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Dashboard stats error:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch dashboard statistics'
            };
        }
    }


}

export const dashboardService = new DashboardService();
export default dashboardService; 